/** Mansion ecosystem contact directory — CheepSweepz satellite mirror */

export const ECOSYSTEM_BRANDS = {
  dhc: {
    brandId: 'dhc',
    displayName: 'Digital Hustlers Caribbean',
    tagline: 'Your Premier Caribbean Business Headquarters',
    supportEmail: 'support@digitalhustlerscaribbean.com',
    infoEmail: 'info@digitalhustlerscaribbean.com',
    primaryDomain: 'https://digitalhustlerscaribbean.com',
  },
  cheepsweepz: {
    brandId: 'cheepsweepz',
    displayName: 'CheepSweepz',
    tagline: 'Global Cross-Border Concierge & Logistics Operations',
    supportEmail: 'concierge@cheepsweepz.shop',
    ordersEmail: 'orders@cheepsweepz.shop',
    primaryDomain: 'https://cheepsweepz.shop',
  },
  navi: {
    brandId: 'navi',
    displayName: 'Navi Assistant',
    tagline: 'Your Smart Island Travel & Local Business Companion',
    supportEmail: 'support@caribnavi.com',
    infoEmail: 'navi@caribnavi.com',
    primaryDomain: 'https://caribnavi.com',
  },
};

export function getEcosystemBrand(brandKey) {
  return ECOSYSTEM_BRANDS[brandKey];
}
